import FooterLinkGroup from "@/components/FooterLinkGroup";
import { automaticFooterColumns, managedFooterColumns } from "@/lib/publications/footerEditor";
import SocialProfileLinks from '@/components/SocialProfileLinks';
import NavigationLinks from '@/components/NavigationLinks';
import { storedNavigationItems } from '@/lib/publications/navigation';

export default function TechnologyFooter({ siteSettings = {}, pages = [], categories = [], footerEditor }) {
  const siteName = siteSettings?.seo?.siteTitle || siteSettings?.organization?.name || 'SURGEDOME';
  const logo = siteSettings?.organization?.logo || null;
  const columns = siteSettings.navigation?.footerManaged ? managedFooterColumns(siteSettings, pages, categories) : automaticFooterColumns(siteSettings, pages);

  return (
    <footer className="mt-12 border-t border-black bg-white px-6 py-12 text-black md:px-10">
      <div className="mx-auto max-w-[var(--container-width,1200px)]">
        <div className="flex flex-col justify-between gap-10 lg:flex-row">
          <div className="max-w-xs">
            {logo ? <img src={logo} alt={siteName} className="max-h-11 max-w-[240px] object-contain" /> : <div className="text-2xl font-black">{siteName}</div>}
          </div>
          <div className="grid flex-1 grid-cols-2 gap-x-8 gap-y-4 text-sm md:grid-cols-4">
            {!siteSettings.navigation?.footerManaged && !footerEditor && Array.isArray(siteSettings.navigation?.footer) ? <NavigationLinks items={storedNavigationItems(siteSettings.navigation.footer, siteSettings)} className="space-y-2.5" /> : columns.map((column, index) => <div key={index} className="flex flex-col gap-2.5"><FooterLinkGroup items={column} position={"col" + (index + 1)} editor={footerEditor} className="space-y-2.5" linkClassName="transition-colors hover:text-[#929191]" /></div>)}
          </div>
          <div>
            <div className="mb-3 text-sm font-bold">Follow Us</div>
            <SocialProfileLinks profiles={siteSettings?.socialProfiles} className="flex max-w-xs flex-wrap gap-2" linkClassName="inline-flex min-w-8 h-8 items-center justify-center border border-black px-2 text-xs font-bold text-black transition-colors hover:border-[#929191] hover:text-[#929191]" />
          </div>
        </div>
        <div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-[#d1d1d1] pt-6 text-xs text-[#666666] sm:flex-row sm:items-center">
          <span>&copy; 2026 SURGEZIRC MEDIA. All rights reserved.</span>
          <img src="/sarjik-signature.png" alt="Sarjik" className="h-5 w-auto object-contain brightness-0" />
        </div>
      </div>
    </footer>
  );
}
